<template>
  <modal
    ref="incompatibleSamplesModal"
    template="neutral"
    ref-name="incompatibleSamplesModal"
    :title="null"
    :icon-enabled="false"
  >
    <aside>
      <div class="create-batch-modal-body">
        <div class="create-batch-modal-body-subtitle">
          Amostras com características divergentes.
        </div>

        <div class="create-batch-modal-body-description">
          Para continuar, as amostras selecionadas precisam ter o mesmo destino, acondicionamento e urgência.
        </div>
      </div>

      <footer class="create-batch-modal-footer">
        <md-button
          class="btn btn-primary"
          @click="close"
        >
          Ok
        </md-button>
      </footer>
    </aside>
  </modal>
</template>

<script>
export default {
  name: 'IncompatibleSamplesModal',
  methods: {
    open() {
      this.$refs.incompatibleSamplesModal.open()
    },
    close() {
      this.$refs.incompatibleSamplesModal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.create-batch-modal {
  .md-button {
    .md-icon {
      width: 1.375rem;
      height: 1.375rem;
      min-width: auto;
      min-height: auto;
    }
  }

  &-body {
    margin-bottom: 1rem;
    font-family: 'Exo 2';
    max-width: 486px;

    &-subtitle {
      font-weight: 700;
      font-style: bold;
      font-size: 1.125rem;
      color: #4A4A4A;
      margin-bottom: 0.5rem;
    }

    &-description {
      font-weight: 400;
      font-size: 1rem;
      color: #666666;
      line-height: 1.5;
    }
  }

  &-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
}
</style>
